<template>
  <div class="m-cta" :class="isMobile?'wap':''">
    <div class="item" v-for="item in ctaList" :key="item.id">
      <img :src="item.icoUrl" alt="">
      <div class="title">{{item.btnName}}</div>
      <div class="qr-code" v-if="item.ctaType == '1'">
        <img :src="item.content" alt="">
      </div>
      <div class="phone" v-if="item.ctaType == '3'">
        {{ item.content}}
      </div>
      <a :href="item.content" class="link"  v-if="item.ctaType == '5' || item.ctaType == '2'"></a>
      <a :href="item.urls && item.urls.pc.normal" class="link"  v-if="item.ctaType == '4' && !isMobile"></a>
      <a   class="link form1"  v-if="item.ctaType == '4' && isMobile" @click="toggleForm(item)"></a>
      <div class="custom-form" v-if="item.ctaType == '4' && isMobile" :class="item.form">
        <span class="icontemp quxiao" @click="toggleForm(item)"></span>
        <div class="iframe">
          <iframe style="background-color: #ffffff" :src="item.urls? item.urls.wap.normal : ''" v-if="item.form == 'show'"  frameborder="0"></iframe>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
  import { interact } from "fire-wind-water";
  import  api from "../../services/api"
  import  {agentType} from "../../../sbase"
  export default {
    props: ["obj"],
    data() {
      return {
        isMobile:interact.isMobile,
        ctaList:[],
        form:'hide',
      };
    },
    watch:{
      "obj.tenantId"(){
        if(this.obj.objId){
          this.getCtaList();
        }
      }
    },

    created() {

    },
    methods: {
      toggleForm(item){
        //企微里iframe 是空的 只能跳转
        if (agentType() === 'wxWork'){
          window.location.href = item.urls.wap.normal;
          return
        }
        item.form = item.form == 'hide'?'show':'hide';
      },
      getCtaList(){
        api.getCtaList({...this.obj}).subscribe(res=>{
          if(res.result == 0){
            this.ctaList = res.content.items.map(item=>{
              if(item.ctaType == '4'){
                item.form = 'hide';
                this.getCustomForm(item);
              }
              return item;
            });
          }

        })
      },
      getCustomForm(item){
        api.getCustomFrom({
          customFormId:item.content,
          tenantId:this.obj.tenantId,
        }).subscribe(res=>{
          item.urls = res.content.shortUrl;
          this.$forceUpdate()
        })
      }
    },
  };
</script>

<style scoped lang="scss">

</style>
